import {NgModule} from '@angular/core';
import {Router} from '@angular/router';
import {CanActivate} from '@angular/router';
import {AuthService} from './auth.service';
import {Store} from '@ngrx/store';
import * as fromStore from './store';

@NgModule({
  providers: []
})

export class AuthGuard implements CanActivate {

  constructor(private auth: AuthService, private router: Router, private store: Store<fromStore.AppState>) {
  }

  canActivate() {
    if (this.auth.loggedIn()) {
      return true;
    }
    this.router.navigate(['/login']);
    return false;
  }
}



// WEBPACK FOOTER //
// /Users/bitcot/Projects/PouredHQ/getpoured-popup-angular/src/app/auth-guard.service.ts